<template>
<div>
    <ul>
        <li class="card" v-for="colmenares in result" :key="colmenares.id" v-bind:id="'colmenar'+colmenares.id">
            <div class="info-item">

                <div class="info-item-list-left">
                    <a v-bind:href="'#/colmenar/' + colmenares.id">
                    <p class="title-box">{{ colmenares.name }}</p>
                    <p>{{ colmenares.localization }}</p>
                    <p class="text-primary vsm-header">{{ colmenares.hives }} colmenas - {{ colmenares.core }} núcleos</p>
                    </a>
                </div>

                <div class="info-item-list-right">

                    <a v-bind:href="'#/colmenar/' + colmenares.id">
                        <v-icon color="grey">mdi-chevron-right</v-icon>
                    </a>

                </div>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
import axios from "axios";

export default {
  name: 'colmenares',
  data: () => ({
    result: null,
  }),
  created() {
        var that = this
        axios.get("https://appws.panimiel.com/new/index.php/api/colmenar").then((result) => {
            that.result = result.data
    })
  }
};
</script>